import { render, staticRenderFns } from "./tagImport.vue?vue&type=template&id=af3d96e0"
import script from "./tagImport.vue?vue&type=script&lang=js"
export * from "./tagImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports